export const getFundTransferTransactionsUrl = transaction_id => {
    return `/fund-transfer-history/${transaction_id}`;
};
export const getFundTransferRequestTransactionsUrl = transaction_id => {
    return `/fund-transfer-request/${transaction_id}`;
};
export const getAllFundTransfersExportUrl = () => {
    return `/fund-transfer-history/export`;
};
